import { createStyles, Theme, makeStyles } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  tableRoot: {
    minWidth: 1230,
    minHeight: 100,
  },
  rowRoot: {
    '&:hover > td': {
      color: theme.appPalette.orange,
    },
  },
  spinnerWrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  tableWrapper: {
    overflowX: 'auto',
    position: 'relative',
  },
});

const useStyles = makeStyles(styles);

export default useStyles;
